import { useEffect } from "react";

const Modal = ({ isVisible, title, content, onClose, actions }) => {
  // Avoid removing the modal from the DOM to prevent re-renders
  const modalClasses = `modal fade ${isVisible ? 'show d-block' : 'd-none'}`;

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains('modal')) {
      onClose();
    }
  };

  // Close modal on Escape key press
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className={modalClasses}
      tabIndex="-1"
      aria-hidden={!isVisible}
      onClick={handleBackdropClick}
    >
      <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">{title}</h4>
            <button type="button" className="close" onClick={onClose}>
              <i className="fa-solid fa-circle-xmark"></i>
            </button>
          </div>
          <div
            className="modal-body"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
          <div className="modal-footer">
            {actions}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
